import { Col, Row } from 'antd'
import { useEffect, useState } from 'react'
import HeaderCard from './HeaderCard'
import { CodeSandboxOutlined, CreditCardOutlined, FileTextOutlined, MailOutlined, PhoneFilled,  UsergroupAddOutlined, UsergroupDeleteOutlined, WalletOutlined } from '@ant-design/icons'
import DashboardService from '../../Services/DashboardService'
import { Utils } from '../../Utilities/Utils'

interface IProps{
    fromDate:string,
    toDate:string
}
interface IStatsRes{
    incoming:number,
    outgoing:number,
    emails:number,
    storageUses:number,
    activeClients:number,
    goCardlessTotalAmount:number,
    invoicesAmount:number,
    receiptsAmount: number,
    stripeTotalAmount:number
}
const HeaderStats = ({fromDate,toDate}:IProps) => {

    const [loading, setLoading] = useState(false);
    const [statsData, setStatsData] = useState<IStatsRes>({
        incoming:0,outgoing:0,emails:0,storageUses:0,
        activeClients:0,goCardlessTotalAmount:0,invoicesAmount:0,receiptsAmount:0,stripeTotalAmount:0
    })

    const getStatsDetails = async () =>{
        try {
            setLoading(true);
            const res = await DashboardService.getPracticeStatsFinancialDetails(fromDate,toDate);
            if (res?.status && res?.result){
                setStatsData({
                    incoming: res?.result?.incoming,
                    outgoing: res?.result?.outgoing,
                    emails: res?.result?.emails,
                    storageUses: res?.result?.storageUses,
                    activeClients: res?.result?.activeClients,
                    goCardlessTotalAmount: res?.result?.goCardlessTotalAmount,
                    invoicesAmount: res?.result?.invoicesAmount,
                    receiptsAmount: res?.result?.receiptsAmount,
                    stripeTotalAmount: res?.result?.stripeTotalAmount
                })
            }
            else{
                setStatsData({
                    incoming:0,
                    outgoing:0,
                    emails:0,
                    storageUses:0,
                    activeClients:0,
                    goCardlessTotalAmount:0,
                    invoicesAmount:0,
                    receiptsAmount:0,
                    stripeTotalAmount:0
                })
            }
        } catch (error) {
            console.error(error)
        }
        finally{
            setLoading(false);
        }
    }
    useEffect(() => {
        getStatsDetails()
    }, [fromDate,toDate])

    return (
        <div style={{ padding: "16px 24px" }}>
            <Row gutter={[16, 16]}>
                {/* <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                    <HeaderCard id="activeClient" fromDate={fromDate} toDate={toDate} title="Active Clients" value={statsData.activeClients} icon={<UsergroupAddOutlined style={{ color: "#1677FF", fontSize: 20 }} />} />
                </Col> */}

                {/* <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                    <HeaderCard title="Inactive Users" value="87" icon={<UsergroupDeleteOutlined style={{ color: "red", fontSize: 20 }} />} />
                </Col> */}

                <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}>
                    <HeaderCard id='incoming' title="Incomming Calls" value={statsData.incoming} icon={<PhoneFilled rotate={100} style={{ color: "#52C41A", fontSize: 16 }} />} loading={loading}  fromDate={fromDate} toDate={toDate}/>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}>
                    <HeaderCard id='outgoing' title="Outgoing Calls" value={statsData.outgoing} icon={<PhoneFilled rotate={100} style={{ color: "#FF4D4F", fontSize: 16 }} />} loading={loading}  fromDate={fromDate} toDate={toDate}  />
                </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}>
                    <HeaderCard id='emails' title="Emails" value={statsData.emails} icon={<MailOutlined style={{ color: "#14b6b6", fontSize: 16 }} />} loading={loading}  fromDate={fromDate} toDate={toDate} />
                </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}>
                    <HeaderCard id='storageUses' title="Storage Uses" value={statsData.storageUses} icon={<CodeSandboxOutlined style={{ color: "#5712d6cb", fontSize: 17 }} />} loading={loading}  fromDate={fromDate} toDate={toDate} />
                </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}>
                    <HeaderCard id='invoice' title="Invoices Amount" value={`£${Utils.getFormattedNumber(statsData.invoicesAmount)}`} icon={<FileTextOutlined style={{ color: "#52C41A", fontSize: 16 }} />} loading={loading}  fromDate={fromDate} toDate={toDate}  />
                </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}>
                    <HeaderCard id='receipts' title="Receipts Amount" value={`£${Utils.getFormattedNumber(statsData.receiptsAmount)}`} icon={<WalletOutlined style={{ color: "#52C41A", fontSize: 16 }} />} loading={loading}  fromDate={fromDate} toDate={toDate} />
                </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}>
                    <HeaderCard id='stripe' title="Stripe Amount" value={`£${Utils.getFormattedNumber(statsData.stripeTotalAmount)}`} icon={<CreditCardOutlined style={{ color: "#1677FF", fontSize: 16 }} />} loading={loading}  fromDate={fromDate} toDate={toDate} />
                </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}>
                    <HeaderCard id='goCardLess' title="GoCardless Amount" value={`£${Utils.getFormattedNumber(statsData.goCardlessTotalAmount)}`} icon={<WalletOutlined style={{ color: "#FAAD14", fontSize: 16 }} />} loading={loading}  fromDate={fromDate} toDate={toDate} />
                </Col>
            </Row>
        </div>
    )
}

export default HeaderStats